/* CADWAX interest scoring + cart-suggestion ordering. Added 2026-10-09.
   The cw_interest cookie is ONLY set after explicit consent (Cookiebot or Shopify Customer Privacy).
   Without consent, cart suggestions still work (server-rendered); this layer stays dormant. */
(function () {
  var COOKIE = 'cw_interest';
  var MAX_AGE_DAYS = 90;
  var CAP = 10;
  var REORDER_MIN = 3;

  var CLUSTERS = {
    academic: ['academic', 'lab-licence', 'universit', 'student', '30x', '30-licence', 'school'],
    architecture: ['visualarq', 'rhinoarq', 'revit', 'architect', 'bim', 'ifc', 'geometry-gym'],
    landscape: ['landsdesign', 'rhinolands', 'landscape'],
    jewellery: ['drakon', 'jewelbeetle', 'jewellery'],
    marine: ['nemo', 'orca3d', 'marine'],
    structural: ['karamba', 'xnurbs', 'structural', 'cyberstrak'],
    productdesign: ['product-design', 'product-designers'],
    animation: ['bongo', 'animation']
  };

  var CLUSTER_PLUGIN = {
    architecture: 'visualarq',
    landscape: 'landsdesign',
    animation: 'bongo'
  };

  function consentOk() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && (cp.marketingAllowed() === true || cp.analyticsAllowed() === true)) return true;
      var cb = window.Cookiebot && window.Cookiebot.consent;
      if (cb && (cb.marketing === true || cb.preferences === true)) return true;
    } catch (e) { /* stay dormant */ }
    return false;
  }

  function readScores() {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
      if (!m) return {};
      var s = JSON.parse(decodeURIComponent(m[1]));
      return (s && typeof s === 'object') ? s : {};
    } catch (e) { return {}; }
  }

  function writeScores(scores) {
    var exp = new Date(Date.now() + MAX_AGE_DAYS * 86400000).toUTCString();
    var val = encodeURIComponent(JSON.stringify(scores));
    document.cookie = COOKIE + '=' + val + '; expires=' + exp + '; path=/; SameSite=Lax';
  }

  function scoreCurrentPage() {
    if (!consentOk()) return;
    var path = window.location.pathname.toLowerCase();
    var scores = readScores();
    var changed = false;
    for (var cluster in CLUSTERS) {
      var keys = CLUSTERS[cluster];
      for (var i = 0; i < keys.length; i++) {
        if (path.indexOf(keys[i]) !== -1) {
          scores[cluster] = Math.min(CAP, (scores[cluster] || 0) + 1);
          changed = true;
          break;
        }
      }
    }
    if (changed) writeScores(scores);
  }

  function topCluster() {
    var scores = readScores();
    var best = null, bestScore = 0;
    for (var c in scores) {
      if (scores[c] > bestScore) { bestScore = scores[c]; best = c; }
    }
    return bestScore >= REORDER_MIN ? best : null;
  }

  function reorder() {
    var wrap = document.getElementById('cw-cart-suggestions');
    if (!wrap) return;
    var c = topCluster();
    if (!c) return;
    var plugin = CLUSTER_PLUGIN[c];
    if (!plugin) return;
    var card = wrap.querySelector('[data-plugin="' + plugin + '"]');
    if (card && card.parentNode && card.previousElementSibling) {
      card.parentNode.insertBefore(card, card.parentNode.firstChild);
    }
  }

  var t = null;
  function observe() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (t) clearTimeout(t);
      t = setTimeout(reorder, 150);
    }).observe(drawer, { childList: true, subtree: true });
  }

  function init() {
    scoreCurrentPage();
    reorder();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('CookiebotOnAccept', scoreCurrentPage);
  document.addEventListener('trackingConsentAccepted', scoreCurrentPage);

  window.CWInterest = {
    clear: function () {
      document.cookie = COOKIE + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    }
  };
})();
